<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/classes/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>مدیریت کلاس {{ }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="students"
                :items-per-page="100"
                disable-sort
                hide-default-footer>
              <template v-slot:[`item.notifications`]="{item}">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab v-bind="attrs" text style="margin-top: -17px!important"
                           v-on="on">
                      <v-badge v-if="item.notifications.length" :content="item.notifications.length" color="#1ab69d">
                        <v-icon size="x-large" class="color-green custom-animation-navbar-middle">mdi-bell-outline
                        </v-icon>
                      </v-badge>
                      <v-icon v-else size="x-large" class="color-green custom-animation-navbar-middle">
                        mdi-bell-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item style="cursor: pointer!important;" v-for="notification in item.notifications"
                                 :key="'notif'+notification.id">
                      <v-list-item-title @click="$router.push(notification.url)">{{ notification.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:[`item.subscription`]="{item}">
                <div v-if="item.subscription">
                  <v-icon color="success">mdi-check</v-icon>
                </div>
                <div v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "OnlineClassManageStudents",
  data() {
    return {
      loading: true,
      students: [],
      onlineClass: null,
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'ایمیل', value: 'email', align: 'center'},
        {text: 'تاریخ تولد', value: 'birth_date_fa', align: 'center'},
        {text: 'شماره همراه', value: 'mobile', align: 'center'},
        {text: 'اعلان ها', value: 'notifications', align: 'center'},
        {text: 'آخرین بازدید', value: 'last_visit_fa', align: 'center'},
        {text: 'اشتراک', value: 'subscription', align: 'center'},
        {text: 'وضعیت', value: 'status', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getClassInfo()
  },
  methods: {
    getClassInfo() {
      let url = '/class/crud/get-students/' + this.$route.params.id
      window.axios.get(url).then((res) => {
        this.onlineClass = res.data.data.class
        this.students = res.data.data.students
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.loading = false
      })
    },

  }
}
</script>

<style scoped>
.student-container {
  background-color: whitesmoke !important;
  border-radius: 10px !important;
}

.custom-margin-lessons {
  margin-top: -1vh !important;
  margin-left: -1vw !important;
}
</style>